export default __webpack_public_path__ + "static/media/Series-9000-MP-Multipoint.b4b9fb72.png";